import React from "react";

const DemoContent: React.FC = () => {
  const features = [
    {
      title: "✅ Predict Inventory with AI",
      description:
        "Eliminate manual tracking. Use AI-powered insights to optimize stock levels and reduce wastage.",
    },
    {
      title: "✅ Streamline Production Management",
      description:
        "Plan, schedule, and track production with ease – no AI required, just smart, efficient control.",
    },
    {
      title: "✅ Track Sales & Purchases in Real-Time",
      description:
        "Monitor your entire sales and procurement process with instant updates and smart alerts.",
    },
    {
      title: "✅ Simplify Billing & Invoicing",
      description:
        "Create, track, and manage all your financial transactions from one centralized system.",
    },
    {
      title: "✅ Make Faster, Smarter Decisions",
      description:
        "Use AI-driven dashboards and real-time analytics to gain actionable business insights.",
    },
  ];

  return (
    <div className="left-content">
      <h2 className="heading-request-demo mb-10 mt-10">We'd love to show you around.</h2>
      <p>
        Sign up for a personalized demo today to see how ActiveCampaign drives
        business growth and to <b>learn about limited-time offers.</b>
      </p>

      <img
        src={'https://y7b6t9n6.delivery.rocketcdn.me/media/uploads/2021/06/30/illustration-2-1-min.png'}
        alt="Placeholder Demo Image"
        className="demo-request-image"
      />

      <h5 className="fw-500 mt-20 mb-20">
        YOUR CUSTOM DEMO WILL SHOW YOU HOW TO:
      </h5>
 
      {features.map((item, index) => (
        <div className="cbox-1 ico-15" key={index}>
          <div className="ico-wrap color--theme" style={{marginBottom:'0px'}}>
          </div>
           <div className="cbox-1-txt">
            <p style={{ fontWeight: "600" }}>{item.title}</p>
            <p>{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DemoContent;
